export default "__VITE_ASSET__PmcgkenD__"